import { loadSwiper } from './swiper-loader.js';

if (!customElements.get('products-carousel')) {
    class ProductsCarousel extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.#init();
        }

        async #init() {
            this.elSection = this.closest('section');
            this.elNext = this.elSection.querySelector('[data-navigation="next"]');
            this.elPrev = this.elSection.querySelector('[data-navigation="prev"]');
            this.enabled = this.getAttribute('enabled') === 'true';

            const Swiper = await loadSwiper();
            this.swiper = new Swiper(this, {
                enabled: this.enabled,
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 10,
                slidesOffsetBefore: 12,
                slidesOffsetAfter: 12,
                speed: 500,
                navigation: {
                    nextEl: this.elNext,
                    prevEl: this.elPrev,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 4,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                    }
                }
            });

            this.setAttribute('data-swiper-ready', '');
        }
    }

    customElements.define('products-carousel', ProductsCarousel);
}
